export const indentRailBaseClasses = 'border-s border-border ps-4';
export const indentRailExpandedClasses = 'h-auto';
export const indentRailExpandedSmallSpacing = 'mt-2';
export const indentRailExpandedSpacing = 'mt-3';
export const indentRailCollapsedClasses = 'invisible mt-0 h-0 overflow-hidden';
